import { render, staticRenderFns } from "./serversListextendView.vue?vue&type=template&id=5a44f9f7&"
import script from "./serversListextendView.vue?vue&type=script&lang=js&"
export * from "./serversListextendView.vue?vue&type=script&lang=js&"
import style0 from "./serversListextendView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a44f9f7')) {
      api.createRecord('5a44f9f7', component.options)
    } else {
      api.reload('5a44f9f7', component.options)
    }
    module.hot.accept("./serversListextendView.vue?vue&type=template&id=5a44f9f7&", function () {
      api.rerender('5a44f9f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/components/serversListextendView.vue"
export default component.exports